

























































































































import { Component, Inject, Vue } from "vue-property-decorator";
import { Sorters } from "@/data/table";
import {
  ITicketsProvider,
  ITicketsProviderMethods
} from "@/models/providers/tickets";
import _ from "@/boot/lodash";
import { ListDisplayMode } from "@/data/constants";
import { UserMetaKeys } from "@/data/enums/users";

@Component
export default class InboxSortControls extends Vue {
  // Inject

  @Inject({ from: "ticketsProvider" })
  public readonly $ticketsProvider!: () => ITicketsProvider;

  @Inject({ from: "ticketsProviderMethods" })
  public readonly $ticketsMethods!: ITicketsProviderMethods;

  // Data

  public isRefreshing = false;
  public availableDisplayModes = [ListDisplayMode.TABLE, ListDisplayMode.INBOX];
  public displayModeStoragePath = UserMetaKeys.UI_SUPPORT_DISPLAY_MODE;
  public displayMode: ListDisplayMode = ListDisplayMode.TABLE;

  // Computed

  public get ticketsProvider() {
    return this.$ticketsProvider();
  }

  public get isInboxLayout() {
    return this.displayMode === ListDisplayMode.INBOX;
  }

  public get inTicketContext() {
    return this.$_.has(this.$route.params, "ticketId");
  }

  public get sorters() {
    return this.ticketsProvider.sorters;
  }

  public get activeSort() {
    const providerActiveSort = this.ticketsProvider.activeSort;

    return _.find(this.sorters, sorter => {
      return (
        sorter.direction === providerActiveSort.direction &&
        sorter.field === providerActiveSort.field
      );
    });
  }

  public get ascendingSorter() {
    return Sorters.ASCENDING;
  }

  public get sortDirectionIcon() {
    return _.get(this.activeSort, "direction") === Sorters.ASCENDING
      ? "sort-amount-up"
      : "sort-amount-down";
  }

  // Methods

  public async refreshInbox() {
    try {
      this.isRefreshing = true;
      await this.$ticketsMethods.refreshInbox();
    } finally {
      this.isRefreshing = false;
    }
  }

  public onSortChange(sort) {
    this.$ticketsMethods.applySort(sort.field, sort.direction);
  }
}
